<ion-buttons mode="md">
  <ion-menu-button
    [attr.data-test]="'Automation.btn-principal-menu' | translate"
    menu="first"
    mode="md"
    class="menu-button"
    (click)="onClickMenu()"
  >
  </ion-menu-button>
</ion-buttons>
